import { createFileRoute } from '@tanstack/react-router';
import { OrderManagementPage } from '@/pages/OrderManagement';

export const Route = createFileRoute('/_admin/order-management/')({
  component: OrderManagementPage,
  validateSearch: (search: Record<string, unknown>) => ({
    page:          typeof search.page === 'number' ? search.page : 1,
    limit:         typeof search.limit === 'number' ? search.limit : undefined,
    search:        search.search as string | undefined,
    status:        search.status as string | undefined,
    tab:           search.tab as string | undefined,
    view:          search.view as string | undefined,
  }),
});
